<div *ngIf="isLoggedIn" class="container">
  <h1>SIMY Főoldal</h1>
  <div class="row">
    
	</div>
</div>
	